var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"admin-footer"}},[_vm._v("\n  2019 © Admin Template. Brought to you by\n  "),_c('a',{attrs:{"href":"https://github.com/ikaiguang"}},[_c('i',{staticClass:"icon icon-user"}),_vm._v("ikaiguang")])])
}]

export { render, staticRenderFns }